import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
export const GetContactsCellTID = (parentTestId)=>getTestIds(parentTestId);
export function ContactsCell(param) {
    let { client, testId } = param;
    var _client_contactsCount;
    const { t: clientsDashboardTexts } = useLocaleKeys('pages.clientsDashboard');
    const { ContactsCellTestIds: CID } = useMemo(()=>GetContactsCellTID(testId), [
        testId
    ]);
    const { primaryContact } = client;
    if (!primaryContact) {
        return /*#__PURE__*/ _jsx(Typography, {
            variant: "paragraph2",
            testId: CID.Root(),
            children: "-"
        });
    }
    const remainingCount = ((_client_contactsCount = client.contactsCount) !== null && _client_contactsCount !== void 0 ? _client_contactsCount : 0) - 1;
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 2,
        testId: CID.Root(),
        children: [
            /*#__PURE__*/ _jsxs(Typography, {
                ellipsis: true,
                variant: "paragraph2",
                children: [
                    primaryContact.name,
                    remainingCount > 0 && clientsDashboardTexts.contactsMore({
                        count: remainingCount
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Typography, {
                ellipsis: true,
                skin: "secondary",
                variant: "paragraph3",
                testId: CID.Email(),
                children: primaryContact.email
            })
        ]
    });
}
